// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__n0-6r","blur":"Modal_blur__lxyzK","modal":"Modal_modal__hdO-A","closeIcon":"Modal_closeIcon__0kJ0r"};